import Vue from 'vue';
import VueRouter, {RouteConfig} from 'vue-router';
import Dashboard from '@/screens/Dashboard.vue';
import LoginScreen from '@/screens/auth/login/LoginScreen.vue';
import RegisterScreen from '@/screens/auth/register/RegisterScreen.vue';
import AuthScreen from '@/screens/auth/AuthScreen.vue';
import Overview from '@/screens/dashboard/overview/Overview.vue';

Vue.use(VueRouter);

const routes: RouteConfig[] = [
    {
        path: '/',
        redirect: {name: 'dashboard.overview'},
    },
    {
        path: '/auth',
        name: 'auth',
        component: AuthScreen,
        children: [
            {
                path: 'login',
                component: LoginScreen,
                name: 'auth.login',
            },
            {
                path: 'register',
                component: RegisterScreen,
                name: 'auth.register',
            },
        ],
        meta: {guestOnly: true},
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: Dashboard,
        children: [
            {
                path: 'overview',
                component: Overview,
                name: 'dashboard.overview',
            },
            {
                path: '/orders',
                component: () => import(/* webpackChunkName: "orders" */ '@/screens/dashboard/orders/OrdersScreen.vue'),
                name: 'dashboard.order',
            },
            {
                path: '/orders/export-tracking',
                component:
                    () => import(/* webpackChunkName: "orders.export_tracking" */ '@/screens/dashboard/orders/OrderTrackingExportScreen.vue'),
                name: 'dashboard.order.export-tracking',
            },
            {
                path: '/tracking',
                component: () => import(/* webpackChunkName: "tracking" */ '@/screens/dashboard/tracking/Tracking.vue'),
                name: 'dashboard.tracking',
            },
            {
                path: '/fulfillment',
                component:
                    () => import(/* webpackChunkName: "fulfillment" */ '@/screens/dashboard/fulfillment/Fulfillments.vue'),
                name: 'dashboard.fulfillment',
            },
            {
                path: '/products',
                component: () => import(/* webpackChunkName: "products" */ '@/screens/dashboard/products/ProductScreen.vue'),
                name: 'dashboard.products',
            },
            {
                path: '/suppliers',
                component: () => import(/* webpackChunkName: "suppliers" */ '@/screens/dashboard/supplier/SupplierScreen.vue'),
                name: 'dashboard.suppliers',
            },
            {
                path: '/suppliers/new',
                component: () => import(/* webpackChunkName: "new_supplier" */ '@/screens/dashboard/supplier/NewSupplierScreen.vue'),
                name: 'dashboard.suppliers.new',
            },
            {
                path: '/suppliers/:supplierId',
                component: () => import(/* webpackChunkName: "new_supplier" */ '@/screens/dashboard/supplier/EditSupplierScreen.vue'),
                name: 'dashboard.suppliers.detail',
            }, {
                path: '/orders/export-orders-to-excel-file',
                component:
                    () => import(/* webpackChunkName: "orders.export_order_to_excel_file" */ '@/screens/dashboard/orders/OrdersExportToExcelFileScreen.vue'),
                name: 'dashboard.order.export-to-excel-file',
            }, {
                path: '/facebook-pixel-management',
                component:
                    () => import(/* webpackChunkName: "facebook-pixel-management" */ '@/screens/dashboard/facebookpixel/FacebookPixelScreen.vue'),
                name: 'dashboard.facebook-pixel-management',
            }, {
                path: '/facebook-pixel-management/new',
                component:
                    () => import(/* webpackChunkName: "new-facebook-pixel" */ '@/screens/dashboard/facebookpixel/NewFacebookPixelScreen.vue'),
                name: 'dashboard.facebook-pixel-management.new',
            }, {
                path: '/facebook-pixels/:id',
                component: () => import(/* webpackChunkName: "new_supplier" */ '@/screens/dashboard/facebookpixel/EditFacebookPixelScreen.vue'),
                name: 'dashboard.facebook-pixel.detail',
            }, {
                path: '/events-management',
                component: () => import(/* webpackChunkName: "new_supplier" */ '@/screens/dashboard/event/EventsAnalyticsScreen.vue'),
                name: 'dashboard.event-management',
            }
        ],
        meta: {requiresAuth: true},
    },

    // {
    //   path: '/about',
    //   name: 'About',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    // },

];

const router = new VueRouter({
    routes,
});

router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('token');
    if (to.matched.some((record) => record.meta.requiresAuth) && !token) {
        next({name: 'auth.login'});
    } else if (to.matched.some((record) => record.meta.guestOnly) && token) {
        next({name: 'dashboard.overview'}); // make sure to always call next()!
    } else {
        next();
    }
});

export default router;
